var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "icon-stroke",
    stroke: "#008383",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.295 15.813c0-3.038 2.458-5.5 5.49-5.5 3.033 0 5.49 2.462 5.49 5.5 0 3.037-2.457 5.5-5.49 5.5-3.032 0-5.49-2.463-5.49-5.5M15.671 12.833L15.671 18.563M18.531 15.698L12.811 15.698",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55 17.188H2.059c-.758 0-1.373-.616-1.373-1.375V6.187c0-.759.615-1.375 1.373-1.375h13.726c.758 0 1.373.616 1.373 1.375v1.375",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.715 5.176L14.134 1.3c-.254-.382-.682-.612-1.14-.613H4.85c-.459 0-.887.23-1.142.613L1.129 5.176M8.922.688L8.922 4.813",
    transform: "translate(1 1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentPlus);
export default __webpack_public_path__ + "static/media/shipment-plus.6bfb3458838dc0ee7b91a365fa93e55f.svg";
export { ForwardRef as ReactComponent };